export default __webpack_public_path__ + "static/media/February_02.814a5af6.png";